import getWindowSearchParam from 'src/app/api/getWindowSearchParam';
import environment from 'src/app/environment';


const getReturnUrl = () => {
  const returnUrl = getWindowSearchParam('returnUrl');
  if (!returnUrl) {
    return environment.accountRecommendations;
  }

  if (returnUrl.charAt(0) === '/') {
    return environment.mainPage + returnUrl;
  }
  if (returnUrl.includes(window.location.protocol) && returnUrl.includes(environment.domain)) {
    return returnUrl;
  }

  return environment.mainPage;
};


export default getReturnUrl;
